import { useState } from 'react';
import { endFinancialContract } from '../../services/FinancialContractLifecycleService';

export default function FinancialContractEndDialog({ clientId, contractId, name, onClose, onEnded }: {
  clientId: string; contractId: string; name: string; onClose: () => void; onEnded: () => void;
}) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  async function confirm() {
    setSaving(true); setError('');
    try { await endFinancialContract(clientId, contractId); onEnded(); }
    catch (cause) { setError(cause instanceof Error ? cause.message : 'Não foi possível encerrar o contrato.'); setSaving(false); }
  }
  return <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" aria-labelledby="contract-end-title">
    <div className="w-full max-w-lg space-y-4 rounded-lg bg-white p-6 shadow-xl">
      <h3 id="contract-end-title" className="text-lg font-semibold">Encerrar contrato?</h3>
      <p className="text-sm text-gray-700"><strong>{name}</strong> passará para a aba Inativos e deixará de estar disponível para novos usos. O contrato, as condições e os registros financeiros anteriores serão preservados.</p>
      {error && <p role="alert" className="rounded border border-red-200 bg-red-50 p-3 text-sm text-red-800">{error}</p>}
      <div className="flex justify-end gap-3 border-t pt-4">
        <button type="button" disabled={saving} onClick={onClose} className="rounded-md border px-4 py-2 disabled:opacity-50">Cancelar</button>
        <button type="button" disabled={saving} onClick={() => void confirm()} className="rounded-md bg-amber-700 px-4 py-2 font-medium text-white disabled:opacity-50">{saving ? 'Encerrando…' : 'Encerrar contrato'}</button>
      </div>
    </div>
  </div>;
}
